module.exports = __webpack_public_path__ + "images/standaard-workslip-220x60.8edfbc198da7e5f8a571.png";